import { ReactNode } from "react";
import { props } from "../../../components/StaffPage/props";
import { RowDataKPI, RowDataStaff } from "../../../components/StaffPage/types";
import DataDisplayTab from "../../DataDisplayTab";
import { KPITypes } from "../../DataDisplayTable/KPITable";
import CurrentTab from "./Tabs/CurrentTab";
import PassTab from "./Tabs/PassTab";

class SelectedStaffDisplayTab extends DataDisplayTab {

    sortBy: keyof RowDataStaff | null;
    setSorting: { (field: keyof RowDataStaff): void };
    Th: { ({ children, sortable, reversed, sorted, onSort }: props): JSX.Element };
    rowData: RowDataKPI[] | null;

    constructor(reverseSortDirection: boolean, sortBy: keyof RowDataStaff | null, setSorting: { (field: keyof RowDataStaff): void }, classes: { readonly [key: string]: string }, Th: { ({ children, sortable, reversed, sorted, onSort }: props): JSX.Element }, rowData: RowDataKPI[] | null, rows: JSX.Element[]) {
        super(reverseSortDirection, classes, rows)
        this.sortBy = sortBy
        this.setSorting = setSorting
        this.Th = Th
        this.rowData = rowData
    }

    createTab(tab: string): ReactNode {
        let errMesssage = "Type must be of KPITypes: "
        Object.keys(KPITypes).forEach((key) => errMesssage += `${key}|`)
        errMesssage = errMesssage.slice(0, errMesssage.length - 1)

        switch (tab) {
            case KPITypes.CURRENT:
                return new CurrentTab(this.sortBy, this.setSorting, this.Th, this.rowData).create(this.reverseSortDirection, this.classes, this.rows)
            case KPITypes.HISTORY:
                return new PassTab(this.sortBy, this.setSorting, this.Th, this.rowData).create(this.reverseSortDirection, this.classes, this.rows)
            default:
                throw new TypeError(errMesssage)
        }
    }
}

export default SelectedStaffDisplayTab
